import { render, staticRenderFns } from "./workflows-index.vue?vue&type=template&id=420fde50&"
import script from "./workflows-index.vue?vue&type=script&lang=js&"
export * from "./workflows-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports